import { AppInsightsProvider } from "Infrastructure/repositories/appInsights/AppInsights";
import { IdleProvider } from "application/contexts/idle/IdleContext";
import NewPrinterProvider from "application/contexts/printer/PrinterProvider";
import { ThemeProvider } from "application/contexts/theme/ThemeContext";
import OrderProvider, {
  IOrderProviderRef,
} from "modules/order/presentation/OrderProvider";
import React, { FC, memo, useRef } from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from "routes/Routes";
import "./App.css";
import { AuthProvider } from "./application/contexts/auth/AuthContext";
import { CardReaderProvider } from "./application/contexts/cardReader/CardReaderContext";
import {
  KioskConsumer,
  KioskProvider,
} from "./application/contexts/kiosk/KioskContext";
import { SessionProvider } from "./application/contexts/session/SessionContext";
import { UIProvider } from "./application/contexts/ui/UIContext";
import "./cores.css";
import ReactNativeBridge from "modules/reactNativeBridge/ReactNativeBridgeExample";
import { usePrinterStore } from "application/contexts/printer/PrinterStore";
import { useOrdersMigration } from "Infrastructure/repositories/localStorage/migration/useOrdersMigration";
import PaymentRecovery from "modules/order/presentation/paymentRecovery/PaymentRecovery";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import { getZoomPortal } from "utils/screenZoom";

// Tema padrão do MUI; só muda onde menus e popovers são montados (zoom da tela).
const muiTheme = createMuiTheme({
  props: {
    MuiPopover: { container: getZoomPortal },
  },
});




const App: FC = memo(() => {
  const orderProvider = useRef<IOrderProviderRef>(null);
  useOrdersMigration();

  return (
    <div className="App">
      <MuiThemeProvider theme={muiTheme}>
      <UIProvider>
        <BrowserRouter>
          <AuthProvider>
            <KioskProvider>
              <KioskConsumer>
                {({ kiosk }) => (
                  <AppInsightsProvider kiosk={kiosk}>
                    <IdleProvider kiosk={kiosk}>
                      <ThemeProvider>
                        <SessionProvider>
                          <CardReaderProvider>
                            <NewPrinterProvider kiosk={kiosk} />
                            <OrderProvider ref={orderProvider} />
                            <PaymentRecovery orderProvider={orderProvider} />
                            <Routes orderProvider={orderProvider} />
                            {/*<PrinterStatus />*/}
                          </CardReaderProvider>
                        </SessionProvider>
                      </ThemeProvider>
                    </IdleProvider>
                  </AppInsightsProvider>
                )}
              </KioskConsumer>
            </KioskProvider>
          </AuthProvider>
        </BrowserRouter>
      </UIProvider>
      </MuiThemeProvider>
      {/* <ReactNativeBridge /> */}
    </div>
  );
});

export default App;



const PrinterStatus = () => {
  const { ordersToPrint } = usePrinterStore();
  return (
    <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      width: "100px",
      height: "100px",
      backgroundColor: "red",
      zIndex: 1000,
    }}
    >
      <p> ordersToPrint: {ordersToPrint.length}</p>
    </div>
  );
};